import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Box, Button, Grid, Typography } from '@material-ui/core'
import { useStyles } from './style'
import { AppButton, Breadcrumb, DisplayMessage, Loader } from '../../Components'
import { TableOutline, Cards } from '../../elements'
import { useParams } from 'react-router-dom'
import { ALL, getSystemsPendingHeadings, SYSTEMSPENDING, APPROVED, REJECTED, APPLICATIONAPPROVED, APPLICATIONREJECTED } from './constant'
import { programService } from '../../Services'
import _ from 'lodash'
import * as messageTypes from '../../utils/messageTypes'
import StatusButton from '../../Components/StatusButton'
import FiberManualRecordOutlinedIcon from '@material-ui/icons/FiberManualRecordOutlined'
import CustomDialog from '../../Components/CustomDialog'
import closeImg from '../../Assets/Images/close.svg'
import checkImg from '../../Assets/Images/check.svg'
import downloadIcon from '../../Assets/Images/download.svg'
import Error404 from '../ErrorPages/Error404'
import { systemsService } from '../../Services/SystemsService/SystemsService'

const filterStatus = {
  'All': '',
  'Approved': 'ENROLLED',
  'Rejected': 'APPLICATION_REJECTED',
  'Pending': 'APPLICATION_SUBMITTED',
  'Withdrawn': 'APPLICATION_WITHDRAWN',
  'Unenrolled': 'UNENROLLED',
  'In Progress': 'APPLICATION_STARTED'
}

function SystemsPending(props) {
  const classes = useStyles()
  const { programId } = useParams()
  const [program, setProgram] = useState({})
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState(false)
  const [headingStatus, setHeadingStatus] = useState(ALL)
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [totalCount, setTotalCount] = useState(1)
  const [tableData, setTableData] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [modalStatus, setModalStatus] = useState()
  const [selectedEnrollment, setSelectedEnrollment] = useState("")
  const [siteDetail, setSiteDetail] = useState([])
  const [showSiteDetail, setShowSiteDetail] = useState(false)
  const [selectedSite, setSelectedSite] = useState()
  const [programStandardization, setProgramStandardization] = useState(false)
  const { currentUser } = useSelector(state => state.auth)

  const handleDropdownChange = (value) => {
    setPage(1)
    setHeadingStatus(value)
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
  }

  const getProgram = () => {
    programService.getProgramsById(currentUser.account_id, programId)
      .then(programData => {
        setProgramStandardization(_.get(programData, 'feature_flags.program_standardization', 'false'))
        setProgram(programData)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getSystemsPending = () => {
    setLoading(true)
    const filter = filterStatus[headingStatus]
    programService.getSystemsPending(currentUser.account_id, programId, page - 1, rowsPerPage, filter)
      .then(systemsPendingData => {
        setSystemsPendingTable(systemsPendingData.enrollments_info)
        setTotalCount(systemsPendingData.total_enrollment_count)
        setLoading(false)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
        setLoading(false)
      })
  }
  const setSystemsPendingTable = (systemsPendingData) => {
    let systemPendingTable = []
    systemsPendingData.map(obj => {
      let siteId = _.get(obj, 'site_id', '-')
      let tableObj = [
        ...programStandardization ? [{
          id: 'site_id',
          className: classes.sidInTable,
          value: <Box className={classes.link} onClick={() => { setSelectedSite(siteId); getSiteDetails(siteId) }}>{siteId}</Box>,
        }] : [],
        {
          id: 'system',
          value: _.get(obj, 'site_name', ''),
        },
        {
          id: 'applicationForm',
          className: classes.idInTable,
          value: <Box ml={6}>{_.get(obj, 'signed_enrollment_form') ? <a href={obj.signed_enrollment_form} target="_blank"><img src={downloadIcon} alt="" /></a> : 'NA'}</Box>,
        },
        {
          id: 'applicationStatus',
          value: (obj.enrollment_status === 'Application_Approved' || obj.enrollment_status === 'Enrollment_Success_Acknowledged_By_HO') ? <StatusButton text="Approved" color="#7ACF38" /> :
            (obj.enrollment_status === 'Application_Rejected' || obj.enrollment_status === 'Enrollment_Failure_Acknowledged_By_HO') ? <StatusButton text="Rejected" color="#CF5538" /> :
              (obj.enrollment_status === 'Unenrolled') ? <StatusButton text="Unenrolled" color="#929699" /> :
                (obj.enrollment_status === 'Application_Withdrawn') ? <StatusButton text="Withdrawn" color="#F9B98F" /> :
                  (obj.enrollment_status === 'Agreement_Certified' || obj.enrollment_status === 'Step1_Completed' ||
                    obj.enrollment_status === 'ApplicationForm_Signed' || obj.enrollment_status === 'Application_DataMissing' ||
                    obj.enrollment_status === 'EAN_added' || obj.enrollment_status === 'ApplicationForm_Downloaded') ? <StatusButton text="In Progress" color="#7ACF38" /> :
                    <Box display="flex">
                      <Button
                        variant="contained"
                        color="primary"
                        disableElevation
                        className={`${classes.button} ${classes.approveButton}`}
                        size="small"
                        onClick={() => {
                          setSelectedEnrollment(obj)
                          setModalStatus('Approve')
                          setModalOpen(true)
                        }}
                      >
                        Approve
                      </Button>
                      <Button
                        variant="outlined"
                        disableElevation
                        className={`${classes.button} ${classes.rejectButton}`}
                        size="small"
                        onClick={() => {
                          setSelectedEnrollment(obj)
                          setModalStatus('Reject')
                          setModalOpen(true)
                        }}
                      >
                        Reject
                      </Button>
                    </Box>,
        },
      ]
      systemPendingTable.push(tableObj)
    })
    setTableData(systemPendingTable)
  }

  const acknowledgeEnrollment = (status) => {
    setLoading(true)
    programService.acknowledgeEnrollment(currentUser.account_id, programId, selectedEnrollment?.id, status)
      .then(enrollmentData => {
        setLoading(false)
        setModalStatus(status)
        getSystemsPending()
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
        setLoading(false)
        setModalStatus(status)
        setModalOpen(false)
      })
  }

  const getModalContent = (status) => {
    if (status === 'Approve') {
      return (
        <Box>
          <Typography className={classes.modalText}>Are you sure you want to approve this application?</Typography>
          <Box display="flex">
            <AppButton className={classes.modalButton} text="Yes, I Approve" onClick={() => { acknowledgeEnrollment(APPLICATIONAPPROVED) }} />
            <AppButton className={classes.modalButton} text="No" fill={false} onClick={() => { setModalOpen(false) }} />
          </Box>
        </Box>
      )
    } else if (status === 'Reject') {
      return (
        <Box>
          <Typography className={classes.modalText}>Are you sure you want to reject this application?</Typography>
          <Box display="flex">
            <AppButton className={classes.modalButton} text="Yes, I Reject" onClick={() => { acknowledgeEnrollment(APPLICATIONREJECTED) }} />
            <AppButton className={classes.modalButton} text="No" fill={false} onClick={() => { setModalOpen(false) }} />
          </Box>
        </Box>
      )
    } else if (status === APPLICATIONAPPROVED || status === APPLICATIONREJECTED) {
      return (
        <Box>
          <Box display="flex" justifyContent="center">
            <img src={checkImg} alt="" />
          </Box>
          <Typography className={classes.modalStatusText}>{`${status === APPLICATIONAPPROVED ? '' : 'Application for'} System ${selectedEnrollment?.site_name} has been successfully ${status === APPLICATIONAPPROVED ? 'enrolled!' : 'rejected'}`}</Typography>
          {status === APPLICATIONAPPROVED && <Box mt={1} display="flex" alignItems="center" justifyContent="center">It will now be visible in “Systems Enrolled” section</Box>}
        </Box>
      )
    } else {
      return (
        <Box>
          <Box display="flex" justifyContent="center">
            <img src={closeImg} alt="" />
          </Box>
          <Typography className={classes.modalStatusText}>{`Application for System ${selectedEnrollment.site_name} has ${modalStatus === 'Close Reject' ? 'not' : ''} been rejected.`}</Typography>
        </Box>
      )
    }
  }

  const getSiteDetails = (siteId) => {
    setLoading(true)
    systemsService.getSystemDetail(currentUser.account_id, programId, siteId)
      .then(systemData => {
        setLoading(false)
        setShowSiteDetail(true)
        setSiteDetail(_.get(systemData, 'formfields.form_data', []))
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getSiteDetailContent = (siteObj) => {
    return (
      <Box>
        <Grid container>
          {siteObj.map(item => {
            return (
              <Grid item xs={6}>
                <Box mb={2}>
                  <Grid container>
                    <Grid className={classes.siteDetailKey} item xs={12}>
                      {item.fieldName}
                    </Grid>
                    <Grid className={classes.siteDetailValue} item xs={12}>
                      {item.fieldValue}
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            )
          })}
        </Grid>
      </Box>
    )
  }

  const renderSystemsPendingTable = () => (
    <>
      <TableOutline
        tableHeadings={getSystemsPendingHeadings(headingStatus, SYSTEMSPENDING, classes, programStandardization)}
        tableData={tableData}
        totalElement={totalCount}
        loading={loading}
        pagination={true}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handlePageChange}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleDropdownChange={handleDropdownChange}
        selectedStatus={headingStatus}
      />
    </>
  )

  useEffect(() => {
    getProgram()
  }, [])

  useEffect(() => {
    getSystemsPending()
  }, [page, rowsPerPage, headingStatus, program])

  const getBreadcrumbs = () => {
    let value = [{ 'Home': '/' }, { 'Programs': '/programs' }]
    if (program) {
      value.push({ [program?.program_name_admin_ui]: `/programs/${program.id}` })
      value.push({ 'Systems Approval': `/programs/${program.id}/systems-approval` })
    } else {
      value.push({ 'Systems Approval': '' })
    }
    return value
  }

  if (program && program.feature_flags && program.feature_flags.system_enrollment_option !== 'SYSTEM_APPROVAL') {
    return (<Error404 />)
  }

  return (
    <Box>
      <Loader loading={loading} />
      <Breadcrumb value={getBreadcrumbs()} />
      {modalOpen && <CustomDialog open={modalOpen} content={getModalContent(modalStatus)} handleClose={() => setModalOpen(false)} />}
      {showSiteDetail && <CustomDialog open={showSiteDetail} title={`Site ID : ${selectedSite}`} content={getSiteDetailContent(siteDetail)} handleClose={() => setShowSiteDetail(false)} />}
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <Box className={classes.headerWrapper} display="flex" flexWrap="wrap" justifyContent='space-between'>
        <Box>
          <Typography className={classes.title}>Systems Approval</Typography>
        </Box>
      </Box>
      <Cards className={classes.cardWrapper} children={renderSystemsPendingTable()} />
      <Box className={classes.bottomText}>
        All approved applications can be located in “Systems Enrolled” section
      </Box>
    </Box>
  )
}

export default SystemsPending